import getDetailsPageHermesAPIUrl from '@stencil/hotels-utils/src/get-details-page-hermes-api-url';

import megatron from '@stencil/megatron';

export default async function fetchDetailsHermesData(dataToMakeHermesUrl) {
  const hermesUrl = getDetailsPageHermesAPIUrl(dataToMakeHermesUrl);

  return await megatron({
    name: 'detailsHermesApi',
    type: 'GET',
    url: hermesUrl,
    trackLatency: {timeout: 2000, data: {serviceApp: 'avatar', apiTimeout: true}},
  });
}
